import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.cherryRed,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 30
  const h = 30
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.75 8.125H8.25A1.125 1.125 0 0 0 7.125 9.25v9a1.125 1.125 0 0 0 1.125 1.125h2.813a2.25 2.25 0 0 1 1.8.9L15 23.125l2.137-2.85a2.251 2.251 0 0 1 1.8-.9h2.813a1.125 1.125 0 0 0 1.125-1.125v-9a1.125 1.125 0 0 0-1.125-1.125ZM8.25 7A2.25 2.25 0 0 0 6 9.25v9a2.25 2.25 0 0 0 2.25 2.25h2.813a1.125 1.125 0 0 1 .9.45L14.1 23.8a1.126 1.126 0 0 0 1.8 0l2.138-2.85a1.125 1.125 0 0 1 .9-.45h2.812A2.25 2.25 0 0 0 24 18.25v-9A2.25 2.25 0 0 0 21.75 7H8.25Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(6 7)" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgComponent
